module.exports = __webpack_public_path__ + "img/two_factor.a1569f7c.svg";